import { render, staticRenderFns } from "./AdminSpecialBetList.vue?vue&type=template&id=0c92f30f&"
import script from "./AdminSpecialBetList.vue?vue&type=script&lang=js&"
export * from "./AdminSpecialBetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports